import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '../Pickers/DatePicker';

interface ReplicateModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (dateUntil: string) => Promise<void>;
}

export const ReplicateModal: React.FC<ReplicateModalProps> = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [untilDate, setUntilDate] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() + 1);
    return d.toISOString().split('T')[0];
  });
  const [loading, setLoading] = useState(false);
  const [inlineError, setInlineError] = useState<string | null>(null);

  if (!open) return null;

  const handleConfirm = async () => {
    setLoading(true);
    setInlineError(null);
    try {
      await onConfirm(untilDate);
      onClose();
    } catch (e: any) {
      const msg = e?.response?.data?.error || e?.message || t('directAvailability.replicateModal.errorGeneric', 'Error al replicar');
      setInlineError(msg);
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="replicate-backdrop open" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-card">
        <div className="modal-header">
          <div>
            <h3>{t('directAvailability.replicateModal.title')}</h3>
            <p>{t('directAvailability.replicateModal.subtitle')}</p>
          </div>
        </div>

        <div className="field">
          <label>{t('directAvailability.replicateModal.until')}</label>
          <div className="replicate-date-wrapper">
             <DatePicker value={untilDate} onChange={setUntilDate} />
          </div>
        </div>

        {inlineError && (
          <div className="replicate-error" role="alert">
            {inlineError}
          </div>
        )}

        <div className="replicate-note">
          {t('directAvailability.replicateModal.note')}
        </div>

        <div className="replicate-actions">
          <button 
            className="btn secondary" 
            type="button" 
            onClick={onClose}
            disabled={loading}
          >
            {t('directAvailability.replicateModal.cancel')}
          </button>
          <button 
            className="btn primary" 
            type="button" 
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? t('directAvailability.replicateModal.replicating', 'Replicando...') : t('directAvailability.replicateModal.replicate')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
